export const disabledStyle = {
  pointerEvents: "none",
  opacity: 0.4,
};
